<template>
<div>
    <el-row>
        <el-col :lg="22" :offset="1">
            <el-table :data="orderList.slice((currentPage-1)*pagesize,currentPage*pagesize)" :header-cell-style="tableHeaderColor" empty-text="暫無數據" style="width: 100%">
                <el-table-column prop="create_datetime" label="日期">
                </el-table-column>
                <el-table-column prop="id" label="單號">
                </el-table-column>

                <el-table-column prop="total" label="金額">
                </el-table-column>

                <el-table-column label="狀態">
                    <template slot-scope="scope">
                        <el-tag type="info">
                            {{scope.row.status == 1 ? '完成':null}}
                            {{scope.row.status == 2 ? '廢止': null}}
                        </el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="user_name" label="美容師">
                </el-table-column>
                <el-table-column prop="shop_name" label="店櫃">
                </el-table-column>

                <el-table-column label="明細">
                    <template slot-scope="scope">
                        <el-button type="info" icon="el-icon-more" @click="detailTabs(scope.$index, scope.row)" circle></el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination background layout="prev, pager, next" :total="total1" @current-change="current_change">
            </el-pagination>
        </el-col>
    </el-row>
</div>
</template>

<script>
import {
    mapGetters,
    mapActions
} from 'vuex'
export default {
    name: 'order',
    props: {
        memberKey: String
    },
    data() {
        return {
            orderList: [],

            total1: 0,
            currentPage: 1,
            pagesize: 10,
        }
    },
    computed: mapGetters(["getOrderList", "UserInfo"]),
    methods: {
        ...mapActions(["fetchOrderList", "fetchUserInfo"]),
        async fetchOrder() {
            const data = {
                member_key: this.memberKey
            }
            await this.$store.dispatch('fetchOrderList', data)
            this.orderList = this.getOrderList
            this.total1 = this.orderList.length

        },

        tableHeaderColor({
            row,
            column,
            rowIndex,
            columnIndex
        }) {
            if (rowIndex === 0) {
                return `background-color: gray;color: #000;`
            }
        },
        detailTabs(index, row) {

            this.orderKey = row._key
            this.$emit('detailTabs', this.orderKey)
        },
        current_change: function (currentPage) {
            this.currentPage = currentPage;
        }
    },
    created() {
        this.fetchOrder()
    },
}
</script>
